import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {messageTextValidation} from '../../../utils/itemValidation';

import * as headerActionCreators from '../../../actions/header';
import * as userActionCreators from '../../../actions/user';
let allActionCreators = Object.assign({}, headerActionCreators, userActionCreators);

import RhinoSelect from '../../common/inputs/RhinoSelect';


class Support extends React.Component {

  static defaultProps = {};

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      serverError: null,
      requestPending: false,
      requestSuccess: false,
      topicValue: '',
      topicError: null,
      messageValue: '',
      messageError: null,
    };
  }

  componentWillMount() {
    let pageTitle = 'Support';
    if(pageTitle !== this.props.header.headerTitle) {
      this.props.headerTitle(pageTitle);
    }
    this.props.headerBack(false);
  }

  getTopicOptions() {
    return [
      {key: 0, value: '', display: 'Select topic'},
      {key: 1, value: 'Technical', display: 'Technical Support'},
      {key: 2, value: 'Feature Request', display: 'Feature Request'},
      {key: 3, value: 'Other', display: 'Other'},
    ];
  }

  changeTopic(evt) {
    this.setState({topicValue: evt.target.value}, () => {
      this.validateTopic();
    });
  }

  changeMessage(evt) {
    this.setState({messageValue: evt.target.value});
  }

  validateMessage() {
    if(this.state.messageError !== null && messageTextValidation(this.state.messageError) === null) {
      this.setState({messageError: null});
    }
  }

  validateTopic() {
    if(this.state.topicError !== null && this.state.topicValue !== '') {
      this.setState({topicError: null});
    }
  }

  dashboardNav() {
    this.context.router.push('/');
  }

  validateAll() {
    let hasErrors = false;
    let topicError = this.state.topicValue === '' ? 'Select a topic' : null;
    let messageError = messageTextValidation(this.state.messageValue);

    if(topicError !== null || messageError !== null) {
      hasErrors = true;
    }

    this.setState({
      topicError: topicError,
      messageError: messageError,
    });

    return !hasErrors;
  }

  sendRequest() {
    if(this.validateAll()) {      
      this.setState({
        serverError: null,
        requestPending: true,
      });
      let supportData = {
        category: this.state.topicValue,
        message: this.state.messageValue,
      };
      this.props.userSubmitSupportRequest(supportData)
      .then((respData) => {
        this.setState({
          requestPending: false,
          requestSuccess: true,
        });
      })
      .catch((errorData) => {
        this.setState({
          serverError: errorData.message,
          requestPending: false,
        });
      });
    }
  }

  render() {
    return <div className='Support'>
      <div className='sectionHeader'>Support</div>
      {this.state.requestSuccess ?
        <div>
          <div className='supportText'>
            We hear you. We've got your message and we'll be contacting your shortly.
          </div>
          <div className='centeredButton'>
            <button 
              className={'supportHome actionButton'}
              onClick={::this.dashboardNav}>
              Home
            </button>
          </div>
        </div> :
        <div>
          <div className='supportText'>
            Need a hand? Have a question or suggestion about something we should add?
          </div>
          <div className='supportText'>
            Send us a message, and we'll get back to you as soon as possible!
          </div>
          {this.state.serverError ? 
            <div className='supportError'>{this.state.serverError}</div> :
            null
          }
          <div className='supportForm'>
            <div className='topicDropdown'>
              <RhinoSelect
                options={this.getTopicOptions()}
                changeMethod={::this.changeTopic}
                error={this.state.topicError !== null} /> 
            </div>
            <div className='userMessage'>
              <textarea
                className={this.state.messageError ? 'textInput error' : 'textInput'}
                placeholder='Enter message'
                value={this.state.messageValue}
                onChange={::this.changeMessage}
                onBlur={::this.validateMessage}>
              </textarea>
            </div>
            <div className='supportButtonRow'>
              <button 
                className={'supportBack secondaryButton'}
                onClick={::this.dashboardNav}>
                Back
              </button>
              <button 
                className={'supportSend actionButton'}
                disabled={this.state.requestPending}
                onClick={::this.sendRequest}>
                Submit
              </button>
            </div>
          </div>
        </div>
      }
    </div>;
  }
}
export default Support;

function mapStateToProps(state) {
  return {
    header: state.header,
  };
}

export const SupportContainer = connect(
  mapStateToProps,
  allActionCreators
)(Support);


// WEBPACK FOOTER //
// ./src/components/views/support/Support.jsx